import { CFormCheck } from '@coreui/react-pro'
import React from 'react'
import './LTCToggleBox.scss'

export default function LTCToggleBox({ onToggleChange, isToggledOn, padding = false }) {
  return (
    <div className={`toggleBox ${padding ? 'padding' : ''}`}>
      <div className="care-label">Care Type</div>
      <div>
        <CFormCheck
          button={{ color: 'primary', variant: 'outline', size: 'sm', shape: 'rounded' }}
          type="radio"
          id="skilled"
          label="Skilled"
          checked={!isToggledOn}
          onChange={() => onToggleChange(false)}
        />
        <CFormCheck
          button={{ color: 'primary', variant: 'outline', size: 'sm', shape: 'rounded' }}
          type="radio"
          id="longterm"
          label="Long-term"
          checked={isToggledOn}
          onChange={() => onToggleChange(true)}
        />
      </div>
    </div>
  )
}
